import fetch from './fetch';

// 教师相关
const jobTile = () => fetch({ url: '/job_title_choose' });
const education = () => fetch({ url: '/education' });
const contractType = () => fetch({ url: '/contract_type' });
const jobStatus = () => fetch({ url: '/job_status' });
const getTeachers = params => fetch({ url: '/teacher', params });
const teacher = ({ params, methold }) => fetch({ url: '/teacher', params, methold });
const getTeacher = ({ params }) => fetch({ url: '/teacher', params });
const controlTeacher = ({ id, params, methold }) => fetch({ url: `/teacher/${id}`, params, methold });
const exportTeacher = ({ params }) => fetch({
  url: '/export_teacher_list', isFull: true, params, config: { responseType: 'blob' }
});

// 合同
const getContract = params => fetch({ url: `/teacher/${params.user_id}/contract`, params });
const addContract = ({ params, user_id, methold }) => fetch({ url: `/teacher/${user_id}/contract`, params, methold });
const controlContract = ({ teacher_contract_record_id, params, methold }) => fetch({
  url: `/teacher_contract/${teacher_contract_record_id}`, params, methold
});
const contractStatus = () => fetch({ url: '/contract_status_select' });

export default {
  addContract,
  contractStatus,
  getContract,
  controlContract,
  jobTile,
  education,
  contractType,
  jobStatus,
  teacher,
  getTeachers,
  controlTeacher,
  getTeacher,
  exportTeacher
};
